export enum BillingType {
  MILESTONE = 'MILESTONE',
  PERIODIC_PREPAID = 'PERIODIC_PREPAID',
  PERIODIC_POSTPAID = 'PERIODIC_POSTPAID',
}
